import React from 'react';

// import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import DisplayCard from '../../components/displaycard';

import Auth from '../../data/auth-service';
import Permissions from '../../data/permissions';

// const useStyles = makeStyles(theme => ({
//     card: {
//         maxWidth: 345,
//     },
// }));

const policies = [
    {
        title: 'OpenText™ NDR',
        description: 'Manage GeoIP, File Hash, Export, Data Tuning, PCAP, and configuration policies',
        img: '/images/logos/Policies_white.png',
        route: '/policies/sensor',
        backgroundColor: '#000000',
        perm: { ...Permissions.Policies.Sensor },
    },
    {
        title: 'Suricata',
        description: 'Modify Suricata rules, groups, and variables',
        img: '/images/logo-suricata.png',
        route: '/policies/suricata',
        backgroundColor: '#FFFFFF',
        perm: { ...Permissions.Policies.Suricata },
    },
    {
        title: 'Zeek',
        description: 'Enable or disable built-in Zeek scripts, manage custom scripts and variables, and export your Zeek script library',
        img: '/images/logo-zeek.png',
        route: '/policies/zeek',
        backgroundColor: '#2757AF',
        perm: { ...Permissions.Policies.Zeek },
    },
];

const Policies = (props) => {
    // const classes = useStyles();

    return (
        <Box mb={2}>
            <Grid container spacing={5}>
                {policies.filter(o => Auth.perm(o.perm)).map((p, i) => {
                    return (
                        <Grid item xl={3} lg={4} key={`policies-zeek-${i}`}>
                            <DisplayCard aria-label={p} {...p} noButton />
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
};

export default Policies;
